import Konva from 'konva/src/Core';
import _ from 'common/customLodash';
import EventEmitter from 'common/eventEmitter';

class PlacingComponent {
    constructor() {
        this.events = new EventEmitter();
        this.konvaObject = new Konva.Group();
        const konaFns = ['setVisible', 'setDraggable', 'setOffset', 'setRotation', 'getRotation', 'destroy', 'moveToTop', 'getZIndex', 'setZIndex'];
        this.addKonvaFunctions(konaFns);

        this.konvaObject.on('mousedown', evt => this.onMouseDown(evt));
        this.konvaObject.on('dragend', evt => this.onDragEnd(evt));
    }

    addKonvaFunctions(functions) {
        functions.forEach(fn => {
            this[fn] = this.konvaObject[fn].bind(this.konvaObject);
        });
    }

    addKonvaNode(node) {
        this.konvaObject.add(node);
    }

    addKonvaComponent(component) {
        this.konvaObject.add(component.konvaObject);
    }

    drawParentLayer() {
        this.konvaObject.getLayer().draw();
    }

    getPos() {
        return this.konvaObject.position();
    }

    setPos({x, y}) {
        if (!_.isUndefined(x)) {
            this.konvaObject.setX(x);
        }
        if (!_.isUndefined(y)) {
            this.konvaObject.setY(y);
        }
    }

    onMouseDown(evt) {
        this.events.emit('mousedown', evt);
    }

    onDragEnd() {
        this.events.emit('dragend');
    }
}

export default PlacingComponent;



// WEBPACK FOOTER //
// ./src/placingEditor/placingComponent.js